import React from 'react';
import KpxSubmissionStatus, {
  KpxSubmissionStatusType,
} from './KpxSubmissionStatus';

interface KpxSubmissionProps {
  text: string;
  className?: string;
  status: KpxSubmissionStatusType;
}

const KpxSubmission: React.FC<KpxSubmissionProps> = ({
  text,
  className,
  status,
}) => {
  return (
    <div className={`${className} flex items-center`}>
      <p className="pop-18-semibold">{text}</p>
      <KpxSubmissionStatus
        status={status}
        className="ml-[8px]"
      ></KpxSubmissionStatus>
    </div>
  );
};

export default KpxSubmission;
